module.exports = __webpack_public_path__ + "img/uptrenixIco.270abac9.png";